/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deactivated_BannedInputs */

const en_deactivated_banned = /** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivated / Banned`)
};

const es_deactivated_banned = /** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivado / Baneado`)
};

const fr_deactivated_banned = /** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivé / Banni`)
};

const de_deactivated_banned = /** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deaktiviert / Verbannt`)
};

const id_deactivated_banned = /** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinonaktifkan / Dilarang`)
};

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const ja_deactivated_banned = en_deactivated_banned;

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const zh_deactivated_banned = en_deactivated_banned;

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const ar_deactivated_banned = en_deactivated_banned;

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const it_deactivated_banned = en_deactivated_banned;

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const ru_deactivated_banned = en_deactivated_banned;

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const pt_deactivated_banned = en_deactivated_banned;

/** @type {(inputs: Deactivated_BannedInputs) => LocalizedString} */
const ko_deactivated_banned = en_deactivated_banned;

/**
* | output |
* | --- |
* | "Deactivated / Banned" |
*
* @param {Deactivated_BannedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const deactivated_banned = /** @type {((inputs?: Deactivated_BannedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deactivated_BannedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deactivated_banned(inputs)
	if (locale === "es") return es_deactivated_banned(inputs)
	if (locale === "fr") return fr_deactivated_banned(inputs)
	if (locale === "de") return de_deactivated_banned(inputs)
	if (locale === "ja") return ja_deactivated_banned(inputs)
	if (locale === "zh") return zh_deactivated_banned(inputs)
	if (locale === "ar") return ar_deactivated_banned(inputs)
	if (locale === "id") return id_deactivated_banned(inputs)
	if (locale === "it") return it_deactivated_banned(inputs)
	if (locale === "ru") return ru_deactivated_banned(inputs)
	if (locale === "pt") return pt_deactivated_banned(inputs)
	return ko_deactivated_banned(inputs)
});